import { ReferenceInput, AutocompleteInput } from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import { useField } from "react-final-form";

interface IStudentInput {
  isDisable?: boolean;
}

const StudentInput = ({ isDisable }: IStudentInput) => {
  const routeIdField = useField("routeId");

  return (
    <ReferenceInput
      label="Select Student"
      source="studentId"
      reference="students"
      filter={{
        SchoolId: Number(SchoolIdSelected()),
        RouteId: Number(routeIdField.input.value),
        Status: "active",
      }}
      disabled={isDisable}
      filterToQuery={(searchText: any) => {
        if (searchText !== "") return { search: searchText };
      }}
    >
      <AutocompleteInput
        optionText={(choice: any) =>
          `${choice?.id} - ${choice?.firstName} ${choice?.lastName}`
        }
        debounce={1000}
      />
    </ReferenceInput>
  );
};

export default StudentInput;
